import * as constants from './constants';

const updatePointOfInterestIdReducer = (
  state = {
    fetching: false,
    success: false,
    pointOfInterest: null,
    errors: null,
    isClicked: false
  },
  action
) => {
  switch (action.type) {
    case constants.UPDATE_POI_LAUNCHED:
      state = {
        ...state,
        fetching: true,
        success: false,
        pointOfInterest: null,
        errors: null
      };
      break;
    case constants.UPDATE_POI_SUCCESS:
      state = {
        ...state,
        fetching: false,
        success: true,
        pointOfInterest: action.pointsOfInterest,
        errors: null
      };
      break;
    case constants.UPDATE_POI_FAILURE:
      state = {
        ...state,
        fetching: false,
        success: false,
        pointOfInterest: null,
        errors: action.errors
      };
      break;
    case constants.SET_MAP_FULL_WIDTH:
      state = {
        ...state,
        isClicked: action.isClicked
      };
      break;
    default:
      break;
  }
  return state;
};

export default updatePointOfInterestIdReducer;
